import { Unsafe } from "@intentsify/types";
import { TooltipProps } from "components";
import { useCallback } from "react";
import { useLocation } from "react-router";
import { useAtomValue } from "jotai";
import { screenAtom } from "utils";

type TrackTooltipOptions = {
  ariaLabel?: Unsafe<TooltipProps["aria-label"]>;
};

export const useTrackTooltipHovered = () => {
  const screen = useAtomValue(screenAtom);
  const location = useLocation();

  return useCallback(
    ({ ariaLabel }: TrackTooltipOptions) => {
      if (!ariaLabel || !screen.name) {
        return;
      }
    },
    [location.pathname, screen.name]
  );
};
